export function processPhoneNumber(phoneNumber: string) {
  return phoneNumber.replace('+', '')
}
